<div class="calendar-window">
    <div class="form">
        <div class="calendar-nav-row">
            <button *ngIf="showDayNavigation && !range" mat-icon-button
                    (click)="goToDay(-1)" [disabled]="isPrevDayDisabled">
                <mat-icon svgIcon="chevron_backward"></mat-icon>
            </button>
            <div class="calendar-component-wrapper">
                <label class="title" *ngIf="title">{{title | translate}}</label>
                <p-calendar
                    [(ngModel)]="calendarValue"
                    (ngModelChange)="modelChange()"
                    class="calendar-component"
                    inline="true" view="date"
                    [selectionMode]="range ? 'range' : 'single'"
                    [minDate]="minDate"
                    [maxDate]="maxRangeDay"
                    [firstDayOfWeek]="1">
                </p-calendar>
            </div>
            <button *ngIf="showDayNavigation && !range" mat-icon-button
                    (click)="goToDay(1)" [disabled]="isNextDayDisabled">
                <mat-icon svgIcon="chevron_forward"></mat-icon>
            </button>
        </div>
        <div *ngIf="showTime" class="time-view">
            <p-calendar [(ngModel)]="time1" (ngModelChange)="modelChange()" class="calendar-component" hourFormat="24" [inline]="true" [timeOnly]="true"
                [showSeconds]="true"></p-calendar>
            <p-calendar [(ngModel)]="time2" (ngModelChange)="modelChange()" *ngIf="range" class="calendar-component"
                hourFormat="24" [inline]="true" [timeOnly]="true" [showSeconds]="true"></p-calendar>
        </div>
        <div class="mb-0 actions">
            <button *ngIf="!autoSubmit" (click)="submit()" [disabled]="!isValid() || (isValid() && !notEmited) || !isChange()" mat-raised-button color="sims">
                {{'submit' | translate}}
            </button>
        </div>
    </div>
</div>